import { render, staticRenderFns } from "./TableEmptySection.vue?vue&type=template&id=bb636b94&scoped=true&"
import script from "./TableEmptySection.vue?vue&type=script&lang=js&"
export * from "./TableEmptySection.vue?vue&type=script&lang=js&"
import style0 from "./TableEmptySection.vue?vue&type=style&index=0&id=bb636b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb636b94",
  null
  
)

export default component.exports